import { HIDE_OVERLAYS } from '@fogia/core-web/state/models/Overlay/constants';
import store from '@fogia/core-web/state/store';

export const hideOverlays =
    (dataToKeep = null) =>
    (dispatch) => {
        dispatch({ type: HIDE_OVERLAYS, data: dataToKeep });
    };

export default (dataToKeep) => store.dispatch(hideOverlays(dataToKeep));
